module.exports = __webpack_public_path__ + "static/media/javascript.de79c8f1.svg";